import { z } from "zod";

export const chatRouteSearchSchema = z.object({
  projectId: z.string().optional(),
});

export type ChatRouteSearch = z.infer<typeof chatRouteSearchSchema>;
